var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00EF8B",
    fillRule: "evenodd",
    d: "M18 8.143h-3.086c-.664 0-1.2.673-1.2 1.32v.394h-3.428v-.394c0-2.383 1.988-4.32 4.444-4.32H18zm-7.714 6.214c0 .673-.399 1.226-1.072 1.226c-.857 0-1.226-.553-1.226-1.226s.553-1.071 1.226-1.071h1.072zm3.428-1.071v.874c0 2.486-2.014 4.697-4.5 4.697a4.505 4.505 0 0 1 0-9h1.072v3.429zm0 0V9.857h3.429v3.429z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.99958925aa5453c6c040bd4e6c71e048.svg";
export { ForwardRef as ReactComponent };